import React from "react";
import { observer } from "mobx-react";
import { match } from "react-router-dom";
import { Location } from "history";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { WrappedNavLink } from "@components/navigation";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";
import { useAppContext } from "@state/hooks/shared";

enum SpecialFooterOptionEnum {
	GAMES,
	CASINO,
	LIVE_CASINO,
	DEFAULT,
}

export default observer(function SpecialFooterOption(props: {
	option: SpecialFooterOptionEnum;
}) {
	const { culture } = useAppContext();
	const { t } = useTranslation();

	const { handleGamesRedirection } = useGamesNavigation();

	if (props.option === SpecialFooterOptionEnum.DEFAULT) {
		return null;
	}

	if (props.option === SpecialFooterOptionEnum.CASINO) {
		return (
			<li className="nav--primary__item">
				<NavLink
					to={`/${culture}/games`}
					className="nav--primary__link"
					activeClassName="is-active"
					isActive={(
						match: match | null,
						location: Location<unknown>
					): boolean => {
						if (location.pathname == `/${culture}/games`) {
							return true;
						} else if (match) {
							return true;
						}
						return false;
					}}
				>
					<span className="nav--primary__icon">
						<i className="nav--primary__icon__inactive u-icon u-icon--base u-icon--slots--reg" />
						<i className="nav--primary__icon__active u-icon u-icon--base u-icon--slots--str u-color--brand--primary" />
					</span>
					<span className="nav--primary__title">
						{t<string>("FOOTER.CASINO")}
					</span>
				</NavLink>
			</li>
		);
	}

	if (props.option === SpecialFooterOptionEnum.LIVE_CASINO) {
		return (
			<li className="nav--primary__item">
				<WrappedNavLink
					to={`/${culture}/live-games`}
					className="nav--primary__link"
					activeClassName="is-active"
					isActive={(
						match: match | null,
						location: Location<unknown>
					): boolean => {
						if (location.pathname == `/${culture}/live-games`) {
							return true;
						} else if (match) {
							return true;
						}
						return false;
					}}
				>
					<span className="nav--primary__icon">
						<i className="nav--primary__icon__inactive u-icon u-icon--base u-icon--live-casino--reg" />
						<i className="nav--primary__icon__active u-icon u-icon--base u-icon--live-casino--str u-color--brand--primary" />
					</span>
					<span className="nav--primary__title">
						{t<string>("FOOTER.LIVE_CASINO")}
					</span>
				</WrappedNavLink>
			</li>
		);
	}

	if (props.option === SpecialFooterOptionEnum.GAMES) {
		return (
			<li className="nav--primary__item">
				<div className="nav--primary__link" onClick={handleGamesRedirection}>
					<span className="nav--primary__icon">
						<i className="nav--primary__icon__inactive u-icon u-icon--base u-icon--slots--reg" />
						<i className="nav--primary__icon__active u-icon u-icon--base u-icon--slots--str u-color--brand--primary" />
					</span>
					<span className="nav--primary__title">
						{t<string>("FOOTER.GAMES")}
					</span>
				</div>
			</li>
		);
	}

	return null;
});
